import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import type { MutationFunction } from "@tanstack/react-query";

export interface SetMfaSecretRequestModel {
	readonly mfaToken: string;
	readonly mfaCode: string;
}

export const useSetMfaSecret = () => {
	const http = useHTTP("Required");

	const mutationFn: MutationFunction<HTTPResponse, SetMfaSecretRequestModel> = requestModel => {
		return http<undefined, SetMfaSecretRequestModel>({
			method: "POST",
			url: "/mfa",
			body: requestModel
		});
	};

	return useHTTPMutation({ mutationFn });
};
